module.exports = __webpack_public_path__ + "static/img/14.7508d7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/14.png
// module id = Zzhv
// module chunks = 0